export default __webpack_public_path__ + "static/media/homeReno.9c0edfe4.png";